import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Popover from 'components/common/Popover'

const Badge = ({
  className,
  category,
  tooltip,
  empty,
  desktop,
  productBadge = false,
  ...props
}) =>
  <Wrapper data-at-badge-wrapper className={ className } empty={ empty } productBadge={ productBadge } >
    { category &&
      <Block desktop={ desktop } productBadge={ productBadge }>
        <Title data-at-bage-title productBadge={ productBadge }>{ category }</Title>
        {
          tooltip && <PopoverWrapper>
            <Popover info={ tooltip } asset="tooltip-white" alternative="tooltip-white-active" data-at-badge-tooltip />
          </PopoverWrapper>
        }
      </Block>
    }
  </Wrapper>

Badge.propTypes = {
  category: PropTypes.string,
  className: PropTypes.string,
  desktop: PropTypes.bool,
  empty: PropTypes.bool,
  productBadge: PropTypes.bool,
  tooltip: PropTypes.string
}

export default Badge


const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  top: 10px;
  ${Mixin.responsive('padding-bottom', '20px', '5px')}
  ${props => props.empty && css`
    && {
      padding-bottom: 0;
    }
  `}
`

const Block = styled.div`
  display: inline-block;
  padding: 5px 7px 6px 10px;
  left: -9px;
  background-color: ${Theme.colors.bright_red_new};
  position: absolute;

  &::after,
  &::before {
    content: '';
    position: absolute;
  }

  &::after {
    top: 0;
    right: -7px;
    border: 7px solid ${Theme.colors.transparent};
    border-top: 30px solid ${Theme.colors.bright_red_new};
  }

  ${props => props.productBadge && css`
    background-color: ${Theme.colors.chartreuse};

    &::after {
      border-top: 30px solid ${Theme.colors.chartreuse};
    }
  `}

  ${props => props.desktop && css`
    &::before {
      top: 100%;
      left: 0;
      border: 4px solid ${Theme.colors.transparent};
      border-top: 4px solid ${Theme.colors.crimson};
      border-right: 4px solid ${Theme.colors.crimson};
    }
  `}
`

const Title = styled.span`
  color: ${Theme.colors.white};
  line-height: 19px;
  ${Mixin.font.GothamBold(13)}

  &::after {
    content: "";
    position: absolute;
    display: block;
    border-style: solid;
    border: 9px solid;
    border-color: #7b170e transparent transparent;
    border-right: transparent;
    bottom: -18px;
    left: 0;
  }

  ${props => props.productBadge && css`
    color: ${Theme.colors.black_new};

    &::after {
      border-color: #abaf28 transparent transparent;
    }
  `}
`

const PopoverWrapper = styled.div`
  position: absolute;
  top: 0;
  right: -22px;
  padding: 8px 2px;
  line-height: 0;
  background-color: ${Theme.colors.dark_red};
  z-index: 1;

  &::after,
  &::before {
    content: '';
    position: absolute;
    border: 10px solid ${Theme.colors.transparent};
    z-index: -1;
  }

  &::after {
    top: 0;
    right: -10px;
    border-top: 30px solid ${Theme.colors.dark_red};
  }

  &::before {
    bottom: 0;
    left: -10px;
    border-bottom: 30px solid ${Theme.colors.dark_red};
  }

  img {
    margin-right: 0;
  }
`
